const rootClass = 'weet-components-radio';
export { rootClass };
